document.querySelectorAll('.copy-wrapper').forEach(wrapper => {
  wrapper.addEventListener('click', function (event) {
    // Désactiver l'événement global de "copy" temporairement
    const globalCopyHandler = function (e) {
      e.stopImmediatePropagation();
    };
    document.addEventListener('copy', globalCopyHandler, true);

    // Copier le code spécifique
    const code = this.getAttribute('data-code');
    const tempInput = document.createElement('input');
    document.body.appendChild(tempInput);
    tempInput.value = code;
    tempInput.select();
    document.execCommand('copy');
    document.body.removeChild(tempInput);

    // Confirmation visuelle
    const overlay = this.querySelector('.overlay');
    const originalText = overlay.textContent;
    overlay.textContent = wrapper.dataset.code.startsWith("كود") ? "تم النسخ!" : "Code copié !";
    setTimeout(() => {
      overlay.textContent = originalText;
    }, 2000);

    // Réactiver l'événement global après un court délai
    setTimeout(() => {
      document.removeEventListener('copy', globalCopyHandler, true);
    }, 100);
  });
});